import { Paper, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useEmployeeWalletRecognitions } from 'store/employees';
import { useRouteParams } from 'utils/useIdParam';
import { Loader, Tile } from 'melp-design/components';
import { usePointsLabel } from 'store/recognitions';
import { formatCurrency } from 'utils/format';
import { useDefaultCurrency } from 'state/Administrators';
import { ROUTES } from 'config';

const RecongitionIncomeSummary = () => {
  const { t, i18n } = useTranslation();
  const { id: employeeId } = useRouteParams(ROUTES.employees.details);
  const pointsLabel = usePointsLabel();
  const { currency } = useDefaultCurrency();

  const { data: recognitions, isLoading } =
    useEmployeeWalletRecognitions(employeeId);

  return (
    <Paper
      variant="outlined"
      sx={{
        borderTop: 0,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        p: '30px 20px',
      }}
    >
      {isLoading ? (
        <Loader />
      ) : recognitions ? (
        <Stack direction="row" gap={2}>
          <Tile
            title={t('wallet.employeeRecognitionAllTime')}
            size="sm"
            items={[
              [recognitions.totalPoints, pointsLabel].join(' '),
              formatCurrency(
                i18n.language,
                recognitions.totalCurrency,
                currency,
              ),
            ]}
          />
          <Tile
            title={t('wallet.employeeRecognitionSpent')}
            size="sm"
            items={[
              [recognitions.spentPoints, pointsLabel].join(' '),
              formatCurrency(
                i18n.language,
                recognitions.spentCurrency,
                currency,
              ),
            ]}
          />
          <Tile
            title={t('benefitExpenses.remaining')}
            size="sm"
            items={[
              [recognitions.availablePoints, pointsLabel].join(' '),
              formatCurrency(
                i18n.language,
                recognitions.availableCurrency,
                currency,
              ),
            ]}
          />
          <Tile
            title={t('status.expired')}
            size="sm"
            items={[
              [recognitions.expiredPoints, pointsLabel].join(' '),
              formatCurrency(
                i18n.language,
                recognitions.expiredCurrency,
                currency,
              ),
            ]}
          />
        </Stack>
      ) : null}
    </Paper>
  );
};

export default RecongitionIncomeSummary;
